import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';

/**
 * SN 維修歷史。
 * GET `/aftersales/repair-item?serial_no=&page=&page_size=`
 *
 * 每筆 `list[]`：`{ repairItem, report, signReceipt }`（signReceipt 僅 ESTABLISHED／COMPLETED）。
 *
 * @param {object} params
 * @param {string} params.serialNo
 * @param {number} [params.page=1]
 * @param {number} [params.pageSize=20]
 */
export async function fetchRepairItemHistoryBySerialNo({
  serialNo,
  page = 1,
  pageSize = 20,
} = {}) {
  const trimmed = String(serialNo ?? '').trim();
  if (!trimmed) {
    throw new Error('serialNo is required');
  }

  const { data: raw } = await request.get('/aftersales/repair-item', {
    params: {
      serial_no: trimmed,
      page,
      page_size: pageSize,
    },
  });
  return parseVer4ListResponse(raw);
}
